export { default } from './emotion-sad'
